import { render, staticRenderFns } from "./RELHistoricoRotas.vue?vue&type=template&id=6432cace&"
import script from "./RELHistoricoRotas.vue?vue&type=script&lang=js&"
export * from "./RELHistoricoRotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports